<template>
  <v-card>
    <v-card-title>
      <span class="title">New</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <form @submit.prevent="formSubmit">

        <v-text-field
          v-model="rank.rank_initial"
          label="Release code"
          :error-messages="errors.collect('release code')"
          v-validate="'required'"
          data-vv-name="release code"
          required
        ></v-text-field>

        <v-text-field
          v-model="rank.description"
          label="Description"
          :error-messages="errors.collect('description')"
          v-validate="'required'"
          data-vv-name="description"
          required
        ></v-text-field>

        <v-btn @click="formSubmit" color="accent" dark :loading="isLoading" :disable="isLoading">save</v-btn>
        <v-btn @click="clear" color="accent" dark>clear</v-btn>
        <v-btn to="/release-code">cancel</v-btn>
      </form>
    </v-card-text>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'new-rank',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      rank: {
        description: '',
        rank_initial: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getLoading',
      getResponse: 'getResponse'
    })
  },
  methods: {
    ...mapActions(['addNewRank']),
    /**
     *
     */
    formSubmit: function () {
      this.loader = 'loading'

      this.$validator.validateAll().then(result => {
        if (result) {
          this.addNewRank(this.rank)
            .then(() => {
              let response = this.getResponse
              this.snackbar = true
              this.text =
                response.status === 200
                  ? 'Added successfully.'
                  : response.data.message
              this.color = response.status === 200 ? 'success' : 'error'
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },
    /**
     *
     */
    clear: function () {
      this.rank.description = ''
      this.rank.rank_initial = ''
    }
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rank/NewRank.vue